import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';

import styles from './styles';
import messages from '../../../components/Fare/messagesFare';
import DicountInformation from '../../../components/Fare/DiscountInformation';

const PlusBusSupplement = ({
    id,
    price,
    classes,
    selected,
    onCheckPlusBusSupplement,
    description,
    discountInfo,
    intl: { formatMessage },
}) => (
    <Paper id={`plusBusSupplement_${id}`} style={styles.cardContainer}>
        <FormControlLabel
            label={discountInfo ? `${price} *` : price}
            classes={{
                label: classes.toggleLabel,
                root: classes.toggleRoot,
            }}
            control={(
                <Switch
                    id={`plusBusSupplementSwitch_${id}`}
                    checked={selected}
                    onChange={onCheckPlusBusSupplement}
                    inputProps={{ style: styles.toggleInput }}
                />
            )}
        />
        <div style={styles.cardText}>{description}</div>
        {
            discountInfo && (
                <DicountInformation
                    fare={discountInfo}
                    discountHeaderLabel={formatMessage(messages.lblDiscountedFare)}
                    discountCardLabel={formatMessage(messages.lblDiscountCard)}
                    promoCodeLabel={formatMessage(messages.lblPromoCode)}
                    validationCodeLabel={formatMessage(messages.lblValidationCode)}
                />
            )
        }
    </Paper>
);

PlusBusSupplement.propTypes = {
    price: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onCheckPlusBusSupplement: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    id: PropTypes.string,
    classes: PropTypes.object.isRequired,
    discountInfo: PropTypes.object,
    intl: PropTypes.object,
};

export { PlusBusSupplement as PlusBusSupplementAlias };

export default injectIntl(withStyles(styles)(PlusBusSupplement));
